// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2pbHK","inputWrap":"Table_inputWrap__1LQPq","col":"Table_col__16q29","bmiTooltip":"Table_bmiTooltip__2n_kR"};